<template>
  <div class="home-container1">
    <header data-role="Header" class="home-navbar-container">
      <Navbar />
    </header>
    <div class="brandschilderen-section-separator1"></div>
    <div class="brandschilderen-section-separator2"></div>
    <div class="brandschilderen-container12">
      <div class="brandschilderen-features">
        <h1 class="brandschilderen-text1">Brandschilderen</h1>
        <div class="brandschilderen-container13">
          <feature-card2
            title="Brandschilderen op glas-in-lood"
            description="Heeft u een glas-in-lood ruit die brand"
            rootClassName="rootClassName8"
          ></feature-card2>
          <feature-card2
            title="Reparatie"
            description="Wanneer uw brandschilderwerk vervaagd is kan Theo Brandt dit voor u oplossen!"
            rootClassName="rootClassName9"
          ></feature-card2>
          <feature-card2
            title="Diversen"
            description="Theo Brandt kan ook Naambordjes, Geboorte kaartjes, Klokken en nog veel meer brandschilderen"
            rootClassName="rootClassName10"
          ></feature-card2>
        </div>
      </div>
    </div>
    <div class="brandschilderen-container14">
      <div class="brandschilderen-gallery1">
        <h1 class="brandschilderen-text2">
          <span>Brandschilderwerk klokken</span>
          <br />
        </h1>
        <div class="brandschilderen-container15">
          <foto-met-tekst
            imageSrc="/brandschilderen/bakker.jpeg"
            title="Bakker"
            rootClassName="foto-met-tekstroot-class-name6"
          ></foto-met-tekst>
          <foto-met-tekst
            imageSrc="/brandschilderen/brandweerwap.1.jpg"
            title="Brandweer"
            rootClassName="foto-met-tekstroot-class-name8"
          ></foto-met-tekst>
          <foto-met-tekst
            imageSrc="/brandschilderen/hoofdtoorn klok hoorn.jpeg"
            title="Hoofdtoren klok hoorn"
            rootClassName="foto-met-tekstroot-class-name7"
          ></foto-met-tekst>
          <foto-met-tekst
            imageSrc="/brandschilderen/klok klubhuis rogues.jpeg"
            title="Klok Clubhuis rogues"
            rootClassName="foto-met-tekstroot-class-name10"
          ></foto-met-tekst>
          <foto-met-tekst
            imageSrc="/brandschilderen/tijgerklok.jpeg"
            title="Tijger klok"
            rootClassName="foto-met-tekstroot-class-name13"
          ></foto-met-tekst>
          <foto-met-tekst
            imageSrc="/brandschilderen/wapen van blokker.jpeg"
            title="Wapen van Blokker"
            rootClassName="foto-met-tekstroot-class-name12"
          ></foto-met-tekst>
        </div>
      </div>
    </div>
    <div class="brandschilderen-container18">
      <div class="brandschilderen-gallery3">
        <h1 class="brandschilderen-text6">Familie/Gemeente wapens</h1>
        <div class="brandschilderen-container19">
          <foto-met-tekst
            imageSrc="/brandschilderen/fam1.jpg"
            title="Familie Brandt"
            rootClassName="foto-met-tekstroot-class-name9"
          ></foto-met-tekst>
          <foto-met-tekst
            imageSrc="/brandschilderen/Wapen van Blokker.JPG"
            title="Wapen van Blokker"
            rootClassName="foto-met-tekstroot-class-name11"
          ></foto-met-tekst>
          <foto-met-tekst
            imageSrc="/brandschilderen/brandweerwapen bovenlicht.JPG"
            title="Brandweer wapen"
            rootClassName="foto-met-tekstroot-class-name14"
          ></foto-met-tekst>
          <Slideshow :slides="wapenVanGulik" />
        </div>
      </div>
    </div>
    <div class="brandschilderen-container20">
      <div class="brandschilderen-gallery4">
        <h1 class="brandschilderen-text7">Naambordjes</h1>
        <div class="brandschilderen-container21">
          <foto-met-tekst
            imageSrc="/brandschilderen/DSC00218.jpeg"
            title="Fam Peetoom"
            rootClassName="foto-met-tekstroot-class-name18"
          ></foto-met-tekst>
          <foto-met-tekst
            imageSrc="/brandschilderen/naambordje fam Zwaal.jpeg"
            title="Fam Zwaal"
            rootClassName="foto-met-tekstroot-class-name19"
          ></foto-met-tekst>
          <foto-met-tekst
            imageSrc="/brandschilderen/voor paardestal trenshoeve  fam. peetoom te berkhout.jpeg"
            title="Fam Peetoom"
            rootClassName="foto-met-tekstroot-class-name20"
          ></foto-met-tekst>
        </div>
      </div>
    </div>
    <div class="brandschilderen-container22">
      <div class="brandschilderen-gallery5">
        <h1 class="brandschilderen-text8">Geboorte Kaartjes</h1>
        <div class="brandschilderen-container23">
          <foto-met-tekst
            title="Geboorte kaartje Timo"
            rootClassName="foto-met-tekstroot-class-name30"
            imageSrc="/brandschilderen/geboortekaartje Timo.jpg"
          ></foto-met-tekst>
          <foto-met-tekst
            title="Timo gebrandschilderd"
            rootClassName="foto-met-tekstroot-class-name31"
            imageSrc="/brandschilderen/geboortekaardje gebrandschilderd lampje timo.jpg"
          ></foto-met-tekst>
          <foto-met-tekst
            title="Geboorte kaartje Indy"
            rootClassName="foto-met-tekstroot-class-name32"
            imageSrc="/brandschilderen/geboortekaartje Indy.jpg"
          ></foto-met-tekst>
          <foto-met-tekst
            title="Indy gebrandschilderd"
            rootClassName="foto-met-tekstroot-class-name33"
            imageSrc="/brandschilderen/geboortekaardjeslaapkamerlampjeindy.jpg"
          ></foto-met-tekst>
        </div>
      </div>
    </div>
    <div class="brandschilderen-container24">
      <div class="brandschilderen-gallery6">
        <h1 class="brandschilderen-text9">Brandschilderwerk</h1>
        <div class="brandschilderen-container25">
          <foto-met-tekst
            title="Vijver"
            rootClassName="foto-met-tekstroot-class-name24"
            imageSrc="/brandschilderen/wegvliegende reiger.JPG"
          ></foto-met-tekst>
          <foto-met-tekst
            title="Ijsvogel"
            rootClassName="foto-met-tekstroot-class-name25"
            imageSrc="/brandschilderen/ijsvogel.JPG"
          ></foto-met-tekst>
          <foto-met-tekst
            title="Tropische vogel"
            rootClassName="foto-met-tekstroot-class-name25"
            imageSrc="/brandschilderen/tropische vogel quetzal.JPG"
          ></foto-met-tekst>
          <foto-met-tekst
            title="Zwart paard"
            rootClassName="foto-met-tekstroot-class-name25"
            imageSrc="/brandschilderen/Zwart paard.JPG"
          ></foto-met-tekst>
          <foto-met-tekst
            title="Liberator"
            rootClassName="foto-met-tekstroot-class-name27"
            imageSrc="/brandschilderen/liberator.jpg"
          ></foto-met-tekst>
          <foto-met-tekst
            title="Nefertiti"
            rootClassName="foto-met-tekstroot-class-name28"
            imageSrc="/brandschilderen/koningin nefertiti.JPG"
          ></foto-met-tekst>
          <foto-met-tekst
            title="Hob"
            rootClassName="foto-met-tekstroot-class-name29"
            imageSrc="/brandschilderen/hop.JPG"
          ></foto-met-tekst>
          <foto-met-tekst
            title="Vaandel drager"
            rootClassName="foto-met-tekstroot-class-name29"
            imageSrc="/brandschilderen/vaandeldrager.JPG"
          ></foto-met-tekst>
          <foto-met-tekst
            title="Timmerman"
            rootClassName="foto-met-tekstroot-class-name29"
            imageSrc="/brandschilderen/timmerman.JPG"
          ></foto-met-tekst>
          <foto-met-tekst
            title="Smid"
            rootClassName="foto-met-tekstroot-class-name29"
            imageSrc="/brandschilderen/smid.JPG"
          ></foto-met-tekst>
          <foto-met-tekst
            title="Glazenier"
            rootClassName="foto-met-tekstroot-class-name29"
            imageSrc="/brandschilderen/glazenier.JPG"
          ></foto-met-tekst>
          <foto-met-tekst
            title="Oud brandschilderwerk"
            rootClassName="foto-met-tekstroot-class-name15"
            imageSrc="/brandschilderen/oudbrandschilderwerk.jpg"
          ></foto-met-tekst>
        </div>
      </div>
    </div>
    <div class="brandschilderen-section-separator6"></div>
    <div class="brandschilderen-section-separator7"></div>
    <div class="brandschilderen-footer-container">
      <Footer />
    </div>
  </div>
</template>

<script>
import FeatureCard2 from "../components/feature-card2";
import FotoMetTekst from "../components/foto-met-tekst";
import Navbar from "../components/navbar";
import Footer from "../components/footer";
import Slideshow from "../components/slideshow.vue";

export default {
  name: "Brandschilderen",
  props: {},
  components: {
    FeatureCard2,
    FotoMetTekst,
    Navbar,
    Footer,
    Slideshow,
  },
  metaInfo: {
    title: "Brandschilderen - Langglas",
    meta: [
      {
        property: "og:title",
        content: "Brandschilderen - Langglas",
      },
    ],
  },
  data() {
    return {
      wapenVanGulik: [
        {
          title: "Wapen van der Gulik",
          imageSrc: "/brandschilderen/wapen v.d Gulik.jpeg",
          imageAlt: "gulik1",
        },
        {
          title: "Wapen van der Gulik in ruit",
          imageSrc: "/brandschilderen/PICT0148.JPG",
          imageAlt: "gulik2",
        },
      ],
    };
  },
};
</script>

<style scoped>
.brandschilderen-section-separator6 {
  width: 100%;
  height: 1px;
  display: flex;
  align-items: flex-start;
  flex-direction: column;
  background-color: var(--dl-color-gray-900);
}
.brandschilderen-section-separator7 {
  width: 100%;
  height: 1px;
  display: flex;
  align-items: flex-start;
  flex-direction: column;
  background-color: var(--dl-color-gray-900);
}
.home-container1 {
  width: 100%;
  height: auto;
  display: flex;
  min-height: 100vh;
  align-items: center;
  flex-direction: column;
}
.home-navbar-container {
  top: 0px;
  left: 0px;
  width: 100%;
  display: flex;
  z-index: 100;
  position: absolute;
  box-shadow: 5px 5px 10px 0px #d4d4d4;
  align-items: center;
  flex-direction: column;
  justify-content: center;
  background-color: #f5ff1c;
}
.home-navbar {
  width: 1550px;
  display: flex;
  max-width: auto;
  align-items: center;
  padding-top: var(--dl-space-space-tripleunit);
  padding-left: var(--dl-space-space-tripleunit);
  padding-right: var(--dl-space-space-tripleunit);
  flex-direction: row;
  padding-bottom: var(--dl-space-space-tripleunit);
}
.brandschilderen-heading1 {
  color: #000000;
  margin-right: var(--dl-space-space-doubleunit);
  text-decoration: none;
}
.brandschilderen-links-container1 {
  width: auto;
  display: flex;
  align-items: flex-start;
  flex-direction: row;
}
.brandschilderen-link10 {
  color: #000000;
  align-self: center;
  margin-right: var(--dl-space-space-tripleunit);
  text-decoration: none;
}
.brandschilderen-link11 {
  color: #000000;
  align-self: center;
  margin-right: var(--dl-space-space-tripleunit);
  text-decoration: none;
}
.brandschilderen-link12 {
  color: #000000;
  align-self: center;
  margin-right: var(--dl-space-space-tripleunit);
  text-decoration: none;
}
.brandschilderen-link13 {
  color: #000000;
  align-self: center;
  margin-right: var(--dl-space-space-tripleunit);
  text-decoration: none;
}
.brandschilderen-link14 {
  color: #000000;
  align-self: center;
  margin-right: var(--dl-space-space-tripleunit);
  text-decoration: none;
}
.brandschilderen-link15 {
  color: #000000;
  align-self: center;
  margin-right: var(--dl-space-space-tripleunit);
  text-decoration: none;
}
.brandschilderen-burger-menu {
  display: none;
  align-items: flex-start;
  flex-direction: column;
}
.brandschilderen-icon1 {
  width: 36px;
  height: 36px;
}
.brandschilderen-mobile-menu {
  top: 0px;
  left: 0px;
  width: 100%;
  height: 100vh;
  display: none;
  padding: var(--dl-space-space-tripleunit);
  position: absolute;
  align-items: flex-start;
  flex-direction: column;
  background-color: #fff;
}
.brandschilderen-container11 {
  flex: 0 0 auto;
  width: 100%;
  display: flex;
  align-items: center;
  margin-bottom: var(--dl-space-space-doubleunit);
  flex-direction: row;
  justify-content: space-between;
}
.brandschilderen-close-menu {
  flex: 0 0 auto;
  display: flex;
  align-items: flex-start;
  flex-direction: column;
}
.brandschilderen-icon3 {
  width: 24px;
  height: 24px;
}
.brandschilderen-links-container2 {
  display: flex;
  align-items: flex-start;
  flex-direction: column;
}
.brandschilderen-link16 {
  margin-bottom: var(--dl-space-space-unit);
}
.brandschilderen-link17 {
  margin-bottom: var(--dl-space-space-unit);
}
.brandschilderen-link18 {
  margin-bottom: var(--dl-space-space-unit);
}
.brandschilderen-section-separator1 {
  width: 100%;
  height: 1px;
  display: flex;
  margin-top: var(--dl-space-space-tenunits);
  align-items: flex-start;
  flex-direction: column;
  background-color: var(--dl-color-gray-900);
}
.brandschilderen-section-separator2 {
  width: 100%;
  height: 1px;
  display: flex;
  align-items: flex-start;
  flex-direction: column;
  background-color: var(--dl-color-gray-900);
}
.brandschilderen-container12 {
  width: 100%;
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;
  background-color: #f1f1f1;
}
.brandschilderen-features {
  width: 100%;
  display: flex;
  padding: 48px;
  max-width: 1400px;
  flex-direction: column;
}
.brandschilderen-text1 {
  font-size: 3rem;
  margin-bottom: 48px;
}
.brandschilderen-container13 {
  width: 100%;
  display: grid;
  grid-gap: 32px;
  grid-template-columns: 1fr 1fr;
}
.brandschilderen-container14 {
  width: 100%;
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;
  background-color: #ffffff;
}
.brandschilderen-gallery1 {
  width: 100%;
  display: flex;
  max-width: 1400px;
  align-items: center;
  padding-top: 32px;
  padding-left: 48px;
  padding-right: 48px;
  flex-direction: column;
  padding-bottom: 32px;
}
.brandschilderen-text2 {
  font-size: 2.5rem;
  align-self: flex-start;
  text-align: center;
  margin-bottom: var(--dl-space-space-unit);
}
.brandschilderen-container15 {
  width: 100%;
  display: grid;
  grid-gap: var(--dl-space-space-unit);
  position: relative;
  grid-template-columns: 1fr 1fr 1fr;
}
.brandschilderen-container16 {
  width: 100%;
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;
  background-color: #f1f1f1;
}
.brandschilderen-gallery2 {
  width: 100%;
  display: flex;
  max-width: 1400px;
  align-items: center;
  padding-top: 32px;
  padding-left: 48px;
  padding-right: 48px;
  flex-direction: column;
  padding-bottom: 32px;
}
.brandschilderen-text5 {
  font-size: 2.5rem;
  align-self: flex-start;
  text-align: center;
  margin-bottom: var(--dl-space-space-unit);
}
.brandschilderen-container17 {
  width: 100%;
  display: grid;
  grid-gap: var(--dl-space-space-unit);
  position: relative;
  grid-template-columns: 1fr 1fr 1fr;
}
.brandschilderen-container18 {
  width: 100%;
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;
  background-color: #ffffff;
}
.brandschilderen-gallery3 {
  width: 100%;
  display: flex;
  max-width: 1400px;
  align-items: center;
  padding-top: 32px;
  padding-left: 48px;
  padding-right: 48px;
  flex-direction: column;
  padding-bottom: 32px;
}
.brandschilderen-text6 {
  font-size: 2.5rem;
  align-self: flex-start;
  text-align: center;
  margin-bottom: var(--dl-space-space-unit);
}
.brandschilderen-container19 {
  width: 100%;
  display: grid;
  grid-gap: var(--dl-space-space-unit);
  grid-template-columns: 1fr 1fr 1fr;
}
.brandschilderen-container20 {
  width: 100%;
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;
  background-color: #f1f1f1;
}
.brandschilderen-gallery4 {
  width: 100%;
  display: flex;
  max-width: 1400px;
  align-items: center;
  padding-top: 32px;
  padding-left: 48px;
  padding-right: 48px;
  flex-direction: column;
  padding-bottom: 32px;
}
.brandschilderen-text7 {
  font-size: 2.5rem;
  align-self: flex-start;
  text-align: center;
  margin-bottom: var(--dl-space-space-unit);
}
.brandschilderen-container21 {
  width: 100%;
  display: grid;
  grid-gap: var(--dl-space-space-unit);
  grid-template-columns: 1fr 1fr 1fr;
}
.brandschilderen-container22 {
  width: 100%;
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;
  background-color: #ffffff;
}
.brandschilderen-gallery5 {
  width: 100%;
  display: flex;
  max-width: 1400px;
  align-items: center;
  padding-top: 32px;
  padding-left: 48px;
  padding-right: 48px;
  flex-direction: column;
  padding-bottom: 32px;
}
.brandschilderen-text8 {
  font-size: 2.5rem;
  align-self: flex-start;
  text-align: center;
  margin-bottom: var(--dl-space-space-unit);
}
.brandschilderen-container23 {
  width: 100%;
  display: grid;
  grid-gap: var(--dl-space-space-unit);
  grid-template-columns: 1fr 1fr 1fr;
}
.brandschilderen-container24 {
  width: 100%;
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;
  background-color: #f1f1f1;
}
.brandschilderen-gallery6 {
  width: 100%;
  display: flex;
  max-width: 1400px;
  align-items: center;
  padding-top: 32px;
  padding-left: 48px;
  padding-right: 48px;
  flex-direction: column;
  padding-bottom: 32px;
}
.brandschilderen-text9 {
  font-size: 2.5rem;
  align-self: flex-start;
  text-align: center;
  margin-bottom: var(--dl-space-space-unit);
}
.brandschilderen-container25 {
  width: 100%;
  display: grid;
  grid-gap: var(--dl-space-space-unit);
  grid-template-columns: 1fr 1fr 1fr;
}
.brandschilderen-footer-container {
  width: 100%;
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;
  background-color: #e2e2e2;
}
.brandschilderen-footer {
  width: 100%;
  display: flex;
  max-width: var(--dl-size-size-maxcontent);
  align-items: center;
  padding-top: var(--dl-space-space-tripleunit);
  padding-left: var(--dl-space-space-tripleunit);
  padding-right: var(--dl-space-space-tripleunit);
  flex-direction: row;
  padding-bottom: var(--dl-space-space-tripleunit);
  justify-content: space-between;
}
.brandschilderen-copyright-container {
  display: flex;
  align-items: center;
  flex-direction: row;
  justify-content: center;
}
.brandschilderen-icon5 {
  width: 24px;
  height: 24px;
  margin-right: var(--dl-space-space-doubleunit);
}
@media (max-width: 1600px) {
  .brandschilderen-navbar {
    width: 90%;
  }
  .brandschilderen-footer {
    justify-content: center;
  }
}
@media (max-width: 1420px) {
  .brandschilderen-container15 {
    grid-template-columns: 1fr 1fr;
  }
  .brandschilderen-container17 {
    grid-template-columns: 1fr 1fr;
  }
  .brandschilderen-container19 {
    grid-template-columns: 1fr 1fr;
  }
  .brandschilderen-container21 {
    grid-template-columns: 1fr 1fr;
  }
  .brandschilderen-container23 {
    grid-template-columns: 1fr 1fr;
  }
  .brandschilderen-container25 {
    grid-template-columns: 1fr 1fr;
  }

  .brandschilderen-navbar {
    width: 100%;
  }
  .brandschilderen-heading1 {
    margin-right: var(--dl-space-space-fourunits);
  }
  .brandschilderen-links-container1 {
    width: auto;
    position: relative;
  }
  .brandschilderen-link10 {
    width: auto;
    height: auto;
  }
  .brandschilderen-link11 {
    width: auto;
    height: auto;
  }
  .brandschilderen-link12 {
    width: auto;
    height: auto;
  }
  .brandschilderen-link13 {
    width: auto;
    height: auto;
  }
  .brandschilderen-link14 {
    width: auto;
  }
  .brandschilderen-link15 {
    width: auto;
  }
}
@media (max-width: 951px) {
  .brandschilderen-heading1 {
    text-align: center;
  }
  .brandschilderen-links-container1 {
    width: 424px;
    display: none;
  }
  .brandschilderen-link10 {
    width: auto;
    height: auto;
  }
  .brandschilderen-link11 {
    width: auto;
    height: auto;
  }
  .brandschilderen-link12 {
    width: auto;
    height: auto;
  }
  .brandschilderen-link13 {
    width: auto;
    height: auto;
  }
  .brandschilderen-link14 {
    width: auto;
    height: auto;
  }
  .brandschilderen-link15 {
    width: auto;
    height: auto;
  }
  .brandschilderen-burger-menu {
    display: flex;
  }
  .brandschilderen-heading2 {
    text-align: center;
  }
  .brandschilderen-container15 {
    grid-template-columns: 1fr;
  }
  .brandschilderen-container17 {
    grid-template-columns: 1fr;
  }
  .brandschilderen-container19 {
    grid-template-columns: 1fr;
  }
  .brandschilderen-container21 {
    grid-template-columns: 1fr;
  }
  .brandschilderen-container23 {
    grid-template-columns: 1fr;
  }
  .brandschilderen-container25 {
    grid-template-columns: 1fr;
  }
}
@media (max-width: 767px) {
  .brandschilderen-navbar {
    position: relative;
  }
  .brandschilderen-links-container1 {
    display: none;
  }
  .brandschilderen-burger-menu {
    display: flex;
    padding: var(--dl-space-space-halfunit);
    margin-left: var(--dl-space-space-tripleunit);
    border-radius: var(--dl-radius-radius-radius4);
    background-color: var(--dl-color-gray-black);
  }
  .brandschilderen-icon1 {
    fill: var(--dl-color-gray-white);
  }
  .brandschilderen-features {
    padding-left: 32px;
    padding-right: 32px;
  }
  .brandschilderen-container13 {
    grid-template-columns: 1fr;
  }
  .brandschilderen-gallery1 {
    padding-left: 32px;
    padding-right: 32px;
  }
  .brandschilderen-container15 {
    grid-template-columns: 1fr;
  }
  .brandschilderen-gallery2 {
    padding-left: 32px;
    padding-right: 32px;
  }
  .brandschilderen-container17 {
    grid-template-columns: 1fr;
  }
  .brandschilderen-gallery3 {
    padding-left: 32px;
    padding-right: 32px;
  }
  .brandschilderen-container19 {
    grid-template-columns: 1fr;
  }
  .brandschilderen-gallery4 {
    padding-left: 32px;
    padding-right: 32px;
  }
  .brandschilderen-container21 {
    grid-template-columns: 1fr;
  }
  .brandschilderen-gallery5 {
    padding-left: 32px;
    padding-right: 32px;
  }
  .brandschilderen-container23 {
    grid-template-columns: 1fr;
  }
  .brandschilderen-gallery6 {
    padding-left: 32px;
    padding-right: 32px;
  }
  .brandschilderen-container25 {
    grid-template-columns: 1fr;
  }
}
@media (max-width: 479px) {
  .brandschilderen-burger-menu {
    margin-left: var(--dl-space-space-doubleunit);
  }
  .brandschilderen-features {
    padding-top: 32px;
    padding-left: var(--dl-space-space-unit);
    padding-right: var(--dl-space-space-unit);
    padding-bottom: 32px;
  }
  .brandschilderen-gallery1 {
    padding: var(--dl-space-space-unit);
  }
  .brandschilderen-container15 {
    grid-template-columns: 1fr;
  }
  .brandschilderen-gallery2 {
    padding: var(--dl-space-space-unit);
  }
  .brandschilderen-container17 {
    grid-template-columns: 1fr;
  }
  .brandschilderen-gallery3 {
    padding: var(--dl-space-space-unit);
  }
  .brandschilderen-container19 {
    grid-template-columns: 1fr;
  }
  .brandschilderen-gallery4 {
    padding: var(--dl-space-space-unit);
  }
  .brandschilderen-container21 {
    grid-template-columns: 1fr;
  }
  .brandschilderen-gallery5 {
    padding: var(--dl-space-space-unit);
  }
  .brandschilderen-container23 {
    grid-template-columns: 1fr;
  }
  .brandschilderen-gallery6 {
    padding: var(--dl-space-space-unit);
  }
  .brandschilderen-container25 {
    grid-template-columns: 1fr;
  }
}
</style>
